import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../Common/Button";

const MerchantPersonalInfo = ({ profileData }) => {
  const navigate = useNavigate();

  return (
    <div className="pt-8">
      <form
        className="space-y-4 md:space-y-6"
        onSubmit={(e) => e.preventDefault()}
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-7">
          {[
            {
              name: "firstName",
              type: "text",
              label: "First Name",
              placeholder: "First name",
            },
            {
              name: "lastName",
              type: "text",
              label: "Last Name",
              placeholder: "Last name",
            },
            {
              name: "email",
              type: "email",
              label: "Email",
              placeholder: "Email",
            },
            {
              name: "mobile",
              type: "tel",
              label: "Phone Number",
              placeholder: "Phone number",
            },
            {
              name: "address",
              type: "text",
              label: "Address",
              placeholder: "Address",
            },
            {
              name: "pinCode",
              type: "tel",
              label: "Pincode",
              placeholder: "Pincode",
            },
            { name: "city", type: "text", label: "City", placeholder: "City" },
            {
              name: "state",
              type: "text",
              label: "State",
              placeholder: "State",
            },
          ].map((field) => (
            <div key={field.name}>
              <label
                htmlFor={field.name}
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800"
              >
                {field.label}
              </label>
              <input
                name={field.name}
                type={field.type}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 focus:outline-none dark:placeholder-gray-400 dark:text-gray-800"
                placeholder={field.placeholder}
                value={profileData?.[field.name] || "N/A"}
                readOnly
              />
            </div>
          ))}
        </div>

        <div className="xl:flex lg:flex md:flex sm:flex justify-end gap-4 pt-5 xl:pt-0 lg:pt-0">
          <div>
            <Button
              type="button"
              text="Back"
              className="border-custom-red border hover:border-custom-red w-full xl:mt-0 lg:mt-0 hover:text-white text-custom-red font-bold py-2 px-4 rounded-lg hover:bg-custom-red transition duration-300"
              onClick={() => navigate(-1)}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default MerchantPersonalInfo;
